var exports = {
  "n": "xfd349460--bfc36f--row",
};

module.exports = exports;
